const INITIALISE_STORE                     = "INITIALISE_STORE";
const SET_CUSTOM_STYLES                    = "SET_CUSTOM_STYLES";
const SET_ACCOUNT_FONTS                    = "SET_ACCOUNT_FONTS";
const SET_ACCOUNT                          = 'SET_ACCOUNT';
const RESET_STORE                          = 'RESET_STORE';
const SET_STORE_STATUS                     = 'SET_STORE_STATUS';
const SET_STORE_LOADING                    = 'SET_STORE_LOADING';
const SET_BLOCK_SEARCH_ENGINE_INDEXING     = 'SET_BLOCK_SEARCH_ENGINE_INDEXING';

const SET_RETRIEVING_BASKET_PROMOTION_CODE = 'SET_RETRIEVING_BASKET_PROMOTION_CODE';
const SET_GROUPED_POSTAGE_TYPES            = 'SET_GROUPED_POSTAGE_TYPES';
const SET_IS_MOBILE                        = 'SET_IS_MOBILE';
const SET_PAYMENT_GATEWAY_LOADED           = 'SET_PAYMENT_GATEWAY_LOADED';
const UPDATE_PRODUCTS_STOCK                = 'UPDATE_PRODUCTS_STOCK';
const UPDATE_REFERRAL_SCHEME = 'UPDATE_REFERRAL_SCHEME';
const UPDATE_REFERRER = 'UPDATE_REFERRER';
const SET_FAVICON                          = 'SET_FAVICON';
const SET_WEBCLIP                          = 'SET_WEBCLIP';
const SET_TOGGLE_DIGITAL_DELIVERY_PRICES   = 'SET_TOGGLE_DIGITAL_DELIVERY_PRICES';

export const state = () => initialState();
import Vue from 'vue';

function initialState () {
  return {
    retrieving_code       : false,
    grouped_postage_types : [],
    tempValidationData: null,

    loading               : true,
    payment_gateway_loaded: false,
    block_search_engine_indexing: false,
    store_status          : false,
    isMobile              : true,
    custom_styles         : {},
    product_stock : {},
    referral_scheme:{},
    referrer:{},
    account: {
      id                         : false,
      PostageTypes               : [],
      domain                     : false,
      Bundles                    : {data : []},
      Products                   : [],
      website                    : false,
      Image                      : false,
      favicon_image              : false,
      webclip_image              : false,
      page_text                  : '',
      footer_text                : '',
      product_button_text        : '',
      name                       : '',
      payment_provider_id        : '',
      show_promotional_code_input: false,
      order_confirmation_heading : '',
      order_confirmation_text    : '',
      toggle_fulfilment          : false,
      Collections                : {data:[]},
      Features                   : {data:[]},
      PaymentIcons :[],
    },
    account_fonts: '',

    toggle_digital_delivery_prices: [],

  }
}

export const mutations = {

    setTempValidationData(state, payload) {
      state.tempValidationData = payload
    },
    clearTempValidationData(state) {
      state.tempValidationData = null
    },

    [RESET_STORE] (state) {

      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },


    [SET_PAYMENT_GATEWAY_LOADED](state, value){
      state.payment_gateway_loaded = value;
    },





    /**
     * Initialises the store to the last state saved in local storage
     */
    [INITIALISE_STORE](state) {

      try{

        // Check if the ID exists
        if(localStorage.getItem('shop_store')) {
          // Replace the state object with the stored item
          let savedState = JSON.parse(localStorage.getItem('shop_store'));
          savedState.loading = true;

          // don't set discount code values to saved states
          //savedState.basketDiscountValue    = initialState().basketDiscountValue;
          //savedState.basketDiscounts        = initialState().basketDiscounts;
          //savedState.basketPromotionalCode  = initialState().basketPromotionalCode;
          savedState.payment_gateway_loaded = initialState().payment_gateway_loaded;

          Object.keys(savedState).forEach(key => {
            state[key] = savedState[key]
          });

        }
      }catch(e) { // local storage disabled, so we won't use it.
        return false;
      }

    },

    // is the store live?
    [SET_STORE_STATUS](state, value){
      state.store_status = value;
    },

    [SET_BLOCK_SEARCH_ENGINE_INDEXING](state, value) {
      state.block_search_engine_indexing = !!value;
    },

    [SET_STORE_LOADING](state, value){
      state.loading = value;
    },



    /**
    * Set custom styles
    * @type {object} custom styles object
    */
    [SET_CUSTOM_STYLES](state, styles) {

        var AccountStyles = {};
        for(var i = 0; i < styles.length; i++) {
            AccountStyles[styles[i].name] = {};
            for(var c = 0; c < styles[i].Components.length; c++) {
                AccountStyles[styles[i].name][styles[i].Components[c].name] = {};
                for(var t = 0; t < styles[i].Components[c].ThemeElements.length; t++) {
                   AccountStyles[styles[i].name][styles[i].Components[c].name][styles[i].Components[c].ThemeElements[t].element_reference] = {};
                    for(var te = 0; te < styles[i].Components[c].ThemeElements[t].ThemeElementStyles.length; te++) {
                        AccountStyles[styles[i].name][styles[i].Components[c].name][styles[i].Components[c].ThemeElements[t].element_reference][styles[i].Components[c].ThemeElements[t].ThemeElementStyles[te].property] = styles[i].Components[c].ThemeElements[t].ThemeElementStyles[te].value;
                    }
                }
            }
        }

        state.custom_styles = AccountStyles;
    },

    /**
    * Set account fonts
    * @type {object} custom styles object
    */
    [SET_ACCOUNT_FONTS](state, value) {
      state.account_fonts = value;
    },

    /**
    * Add ab item to the basket
    * @type {object} basket item
    */
    [SET_ACCOUNT](state, value) {

      for(let i=0; i < value.Products.length; i++) {

          // Sort by price
          value.Products[i].PriceModifiers.sort(function(a,b){
              return a.price - b.price;
          });
      }
      state.account = value;
    },

    [SET_FAVICON ] (state, value) {
      state.favicon_image = value;
    },

    [SET_WEBCLIP ] (state, value) {
      state.webclip_image = value;
    },

    [SET_TOGGLE_DIGITAL_DELIVERY_PRICES ] (state, value) {
      state.toggle_digital_delivery_prices = value;
    },

    /**
    * Store grouped postage types
    * @type array of postage types
    */
    [SET_GROUPED_POSTAGE_TYPES](state, value) {
      state.grouped_postage_types = value;
    },




    [SET_RETRIEVING_BASKET_PROMOTION_CODE] (state, value) {
      state.retrieving_code = value;
    },

    [SET_IS_MOBILE] (state, value) {
      state.isMobile = value;
    },

  /**
   * Update the products stock based on the CDN file
   * @type {object} products stock json
   */
  [UPDATE_PRODUCTS_STOCK](state,products) {
    state.product_stock = products;
  },

  [UPDATE_REFERRAL_SCHEME](state, value){
    state.referral_scheme = value;
  },
  [UPDATE_REFERRER](state, value){
    state.referrer = value;

  },

}

export const getters = {

  // returns stock status for a product
    getProductStock: (state, getters) => (product, isTicket, unitId, timeId) => {

      if(!state.account)
        return null;

      if (isTicket) {

          let basket = getters["basket/getBasket"];

          let products_in_basket = basket.reduce((total, basket_product) => {

            if ((basket_product.id == product.id) && (basket_product.event_location == unitId) && (basket_product.event_time.id == timeId)) {
              return basket_product.quantity + total
            } else {
              return total
            }

          },0);

          let stock_remaining = null;

          if (state.product_stock[product.id] && state.product_stock[product.id][unitId]) {
            stock_remaining = state.product_stock[product.id][unitId][timeId];
          }


          if(stock_remaining !== null)
            stock_remaining = stock_remaining - products_in_basket;


          return {
              status              : stock_remaining !== null ? true : false, // is stock availablity used by this product?
              sold_out            : (stock_remaining !== null && stock_remaining <= 0) ? true : false,
              stock_remaining     : stock_remaining,
              show_stock_remaining: (stock_remaining !== null && stock_remaining <= 0) || (product.display_remaining_at && stock_remaining <= product.display_remaining_at) ? true : false,
              display_text        : product.sale_limit == product.display_remaining_at ? stock_remaining + ' available' : 'Only '+stock_remaining+' left'
          }

      } else {

        let basket             = getters["basket/getBasket"];

        let products_in_basket = basket.reduce((total,basket_product)=>{return basket_product.id == product.id ? basket_product.quantity+total : total},0);
        let stock_remaining = state.product_stock[product.id];

        if(stock_remaining !== null)
          stock_remaining = stock_remaining - products_in_basket;

        return {
            status              : stock_remaining !== null ? true : false, // is stock availablity used by this product?
            sold_out            : (stock_remaining !== null && stock_remaining <= 0) ? true : false,
            stock_remaining     : stock_remaining,
            show_stock_remaining: (stock_remaining !== null && stock_remaining <= 0) || (product.display_remaining_at && stock_remaining <= product.display_remaining_at) ? true : false,
            display_text        : product.sale_limit == product.display_remaining_at ? stock_remaining + ' available' : 'Only '+stock_remaining+' left'
        }
      }



    },


    geTempValidationData:(state)=>{
      return state.tempValidationData;
    },



    getPaymentGatewayLoaded:(state)=>{
      return state.payment_gateway_loaded;
    },
    getStylesById: (state) => (theme, component, element_id) => {
      if(state.custom_styles[theme] && state.custom_styles[theme][component] && state.custom_styles[theme][component][element_id])
        return state.custom_styles[theme][component][element_id];
      return {};
    },
    // pass in a feature id and returns the feature if it's active on the account
    getFeature: (state) => (feature_id) => {
      let feature = state.account.Features.data.find(feature => feature.id === feature_id);
      return feature ? feature : null;
    },
    getCustomStyles: state => {
      return state.custom_styles
    },
    getAccountFonts: state => {
      return state.account_fonts
    },
    getProducts: state => {

      let products = state.account.Products;
      let bundles = state.account.Bundles.data;

      if(!products.length)
        return [];

      for(let i=0; i < products.length; i++) {

        products[i].bundle = false;
        /* if product has validity rules and expiry rules set */
        if(
          products[i].CurrentExpiryConfig &&
          products[i].CurrentExpiryConfig.hard_expire_at &&
          products[i].ValidityRules &&
          products[i].ValidityRules.length > 0
        ){
          for(var x = 0; x < products[i].ValidityRules.length; x++) {

            /* if product has start validity after X days */
            if(products[i].ValidityRules[x].product_validity_rule_type_id == 3) {

              let seconds = products[i].ValidityRules[x].rule;
              let days = seconds / 60 / 60 / 24;
              let estimateValidityDate = new Date();
              estimateValidityDate.setDate(estimateValidityDate.getDate() + days);
              let hardExpiry = new Date(products[i].CurrentExpiryConfig.hard_expire_at);

              /* if card will become available after expiry remove from products array */
              if(estimateValidityDate > hardExpiry) {
                products.splice(i,1);
              }

            }
          }
        }
      }

      // make an array of available product ids
      let productIds = products.map(product => product.id);

      let returnableProducts = [];

      // add bundles to the product array
      for(let i=0; i < bundles.length; i++) {
        bundles[i].bundle = true;

        //If all products within a bundle are valid, then add the bundle to the products list.
        let bundle_product_ids = bundles[i].PriceModifiers.map(pm => pm.Product.id);
        // check to see if all prodict ids in the bundle are in the valid productIds array
        let all_available = bundle_product_ids.filter(x => productIds.includes(x));
        if(all_available.length == bundle_product_ids.length)
          returnableProducts.push(bundles[i]);
      }

      for(let i=0; i < products.length; i++)
        returnableProducts.push(products[i]);


      return returnableProducts;
    },
    getStandardProducts: state => {
      return state.account.Products.filter(product => product.type == "standard")
    },
    getExperienceProducts: state => {
      return state.account.Products.filter(product => product.type == "experience")
    },
    getProductById: (state) => (id) => {
      return state.account.Products.find(product => product.id == id)
    },
    getProductBySlug: (state) => (slug) => {
      let product =  state.account.Products.find(product => product.slug == slug);
      if(!product){
        product = state.account.Bundles.data.find(bundle => bundle.slug == slug);
      }

      return product;
    },
    getCollections: state => {
      // Make copy of collections to avoid Vuex error
      let collections = [...state.account.Collections.data];
      return collections.sort((a, b) => a.webshop_order - b.webshop_order);
    },
    getCollectionBySlug: (state) => (slug) => {
      let collection =  state.account.Collections.data.find(collection => collection.slug === slug);

      return collection;
    },
    getBundles: state => {
      return state.account.Bundles;
    },

    getAccountId: state => {
      return state.account.id;
    },
    getRetrievingBasketPromoCode: state => {
      return state.retrieving_code;
    },
    getPostageTypes: (state) => {
      return state.account.PostageTypes;
    },
    getGroupedPostageTypes: (state) => {
      return state.grouped_postage_types;
    },
    getAccountDomain: (state) => {
      return state.account.domain;
    },
    getAccountWebsite: (state) => {
      return state.account.website;
    },
    getAccountLogo: (state) => {
      return state.account.Image ? state.account.Image.url : false;
    },
    getShouldResizeAccountLogo: (state) => {
      return !!state.account.should_resize_webshop_logo
    },
    getFavicon: (state) => {
      return state.account.FaviconImage ? state.account.FaviconImage.url : false;
    },
    getWebclip: (state) => {
      return state.account.WebclipImage ? state.account.WebclipImage.url : false;
    },
    getAccountPageText: (state) => {
      return state.account.page_text;
    },
    getStripeKey: (state) => {

      if(
        state.account.PaymentProviderAccount &&
        state.account.PaymentProviderAccount.payment_provider_id == 1 &&
        state.account.PaymentProviderAccount.PaymentProviderAccountConfigs.length
      ){
        let config = state.account.PaymentProviderAccount.PaymentProviderAccountConfigs.filter(function (el) {
        return el.payment_provider_attribute_id == 2
      });
      if(config.length == 1 && config[0].content)
        return config[0].content;
      }

      return false;
    },
    getStoreStatus: (state) => {
      return state.store_status;
    },
    getBlockSearchEngineIndexing: (state) => {
      return state.block_search_engine_indexing;
    },
    getLoading: (state) => {
      return state.loading;
    },
    getAccount: (state) => {
      return state.account;
    },
    getAccountConsents: (state) => {
      return state.account.Consents;
    },
    getIsMobile: (state)  => {
      return state.isMobile;
    },
    getReferralSchemeBySlug: (state) => (slug) => {
      if(state.referral_scheme.slug == slug){
        return state.referral_scheme;
      }
      return null;
    },
    getReferralSchemeByReferrerSlug: (state) => (slug) => {
      if(state.referrer.referrer_slug == slug){
        return state.referrer;
      }
      return null;
    },



    getAgeVerified: (state, getters, rootState) => {
      return !!(rootState.persisted && rootState.persisted.age_verified);
    },
    getToggleDigitalDeliveryPrices:state => {
      return state.toggle_digital_delivery_prices;
    },
    getAccountDateFormat: (state) => {
      return state.account.TimeConfig ? state.account.TimeConfig.date_format : 'd/m/Y';
    }
}



export const actions = {

    storeOffline({commit}, router){
      commit('SET_STORE_STATUS',false);
      router.push({'name':'offline'});
    },

    resetPersistedData({commit}){

      commit('persisted/RESET_STORE');
      commit('basket/RESET_STORE');


    },

    resetStore({commit}){
        commit('RESET_STORE')
        commit('persisted/RESET_STORE')
        commit('basket/RESET_STORE')
    },

    /**
    * Update basket quantity configs all with the same daya
    * @type {object} config object - {newValue: // the new value you want to set the index, index: // the index you want to set on the quantity config,
    * basketItem: [{ basket_index: // the index of the basket item the quanitty item belongs to, quantity_index:[array of quantity indexes] }] }
    *
    * @type {object} address
    */
    updateQuantityConfig({ commit }, value)
    {

      for (var i = 0; i < value.basketItem.length; ++i) {
        for (var e = 0; e < value.basketItem[i].quantity_index.length; ++e) {

          commit("basket/UPDATE_QUANTITY_CONFIG",
            {
              basket_index: value.basketItem[i].basket_index,
              quantity_index: value.basketItem[i].quantity_index[e],
              value: {[value.index]: value.newValue}
            }
          )

        }
      }

    },




  /**
   * Gets the shop load data
   * Called serverside before the client has loaded
   */
	async nuxtServerInit ({ commit }, { req, app:{router}, error } ) {


    // If we're on the busy page, don't try and access the API, this is the load balancing page
    if(router.history.current.name == 'queue')
      return;

    try{

        // Check the cache for a homepage data file (this should theoretically always return a cache)
        let result =  await this.$cacheRead({key:'homepage'});

        // If for some unforseen reason we don't have a cache file, then get the data from the API. This should in theory never happen
        if(!result){
          // Get the query needed from the API - it's done this way so the dataset is exatly the same as the cache data query
            const getAccountQuery = await this.$axios.$get(process.env.VUE_APP_API_BASE_URL+'/api/webstore-queries/accounts?host='+req.headers.host, { headers: { 'X-Webstore-Key': process.env.WEBSTORE_API_SECRET } });

            result = await this.$axios.$post(
              process.env.VUE_APP_API_GRAPH_URL,
              {
                query: getAccountQuery,
                variables: {
                    domain: req.headers.host,
                    product_active: 1,
                    collection_active: true,
                    postage_type_active: 1,
                    store_type_id:1,
                    order_by: 'webshop_order'
                }
              },
              { headers: { 'X-Webstore-Key': process.env.WEBSTORE_API_SECRET } }
            );
            if(result.data.Accounts[0].id){
                await this.$cacheWrite({key:'homepage',expire:process.env.CACHE_LENGTH_SECONDS},JSON.stringify(result));
                await this.$cacheWrite({ key:'maximum_requests', expire: process.env.CACHE_LENGTH_SECONDS }, result.data.Accounts[0].maximum_requests);
            }else{
                throw "no account found";
            }


        }else{
          result = JSON.parse(result);
        }

        commit('SET_STORE_LOADING',false);

        if(result == 404){
          // this shop doesn't exist
          throw 404;
        }
        else if(result.data.Accounts.length){
          commit("SET_STORE_STATUS",result.data.Accounts[0].storeLive);
          commit("SET_BLOCK_SEARCH_ENGINE_INDEXING", result.data.Accounts[0].blockSearchEngineIndexing);
          commit("SET_ACCOUNT",result.data.Accounts[0]);
          commit('SET_CUSTOM_STYLES', result.data.AccountStyles);
          if(result.data.AccountFonts.length)
            commit('SET_ACCOUNT_FONTS', result.data.AccountFonts[0].font_library);
          commit("SET_TOGGLE_DIGITAL_DELIVERY_PRICES", result.data.ToggleDigitalDeliveryPrices)
        }

      } catch(e){


        // show 404 page
        if(e == 404){
          return error({ statusCode: 404, message: '' });
        }

        // if the API returned a bad request, set cache to 404 so we don't keep calling the API
        if(e.response.status == 400){
          await this.$cacheWrite({key:'homepage',expire:process.env.CACHE_LENGTH_SECONDS},404);
          await this.$cacheWrite({ key:'maximum_requests', expire: process.env.CACHE_LENGTH_SECONDS }, result.data.Accounts[0].maximum_requests);
        }

        // something else happened.
        if(!e.response || (e.response.status != 503 && e.response.status != 400)){
          error();
        }
      }

	}
}
